import {type KeyboardShortcut, PlatformCommandKey} from 'common/util/keyboard-shortcut';
import {KeyModifiers} from 'common/util/keyboard';

/**
 * The app-wide undo/redo bindings. `HistoryManager` binds them and the command
 * palette's Actions rows label them from here, so there is one declaration to
 * change if the shortcut ever moves.
 */
export const UNDO_SHORTCUT: KeyboardShortcut = {code: `KeyZ`, modifiers: [PlatformCommandKey]};

export const REDO_SHORTCUT: KeyboardShortcut = {code: `KeyZ`, modifiers: [PlatformCommandKey, KeyModifiers.Shift]};
